export default __webpack_public_path__ + "static/media/laliga.6ae1989b.png";